import { View } from "react-native";
import { TranslateText } from "./translate-text";

const ProgressBar = ({completed_tasks, total_tasks}) => {
    return (
        <View
          style={{
            paddingHorizontal: 8,
            width: "100%",
            marginBottom: 8,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
            <TranslateText
            style={{
                fontWeight: "500",
                fontStyle:'italic',
                fontSize: 16,
                lineHeight: 19,
                paddingVertical: 12,
            }}
            >
            Progress
            </TranslateText>
            <Bar completed_tasks={completed_tasks} total_tasks={total_tasks} />
        </View>
        
    )
}

const Bar = ({completed_tasks, total_tasks}) => {
    return (
        <View
            style={{
                flex: 1, 
                height: 8,
                backgroundColor: "#C2C2C2",
                borderRadius: 20,
                marginVertical: 12,
                flexDirection: "row",
                alignItems: "center",
                marginLeft:40
            }}
            >
                <View
                    style={{
                    width: completed_tasks >= total_tasks ? '100%' :`${
                        (completed_tasks * 100) / total_tasks
                    }%`,
                    height: 8,
                    backgroundColor: "#33CF71",
                    borderRadius: 20,
                    }}
                ></View>
        </View>
        )
}

export default ProgressBar;